/// <amd-module name="Artifacts/Root/helpers/DataProviderHelpers" />

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export async function loadData<T>(
  context: IVssPageContext,
  contributionId: string,
  requestParameters?: { [key: string]: any },
  ignoreCache?: boolean,
  serviceInstanceType?: string,
): Promise<T | null> {
  const contributionService = context.getService<IVssContributionService>(
    "IVssContributionService",
  );
  const data = await contributionService.getDataAsync<T | null>(
    contributionId,
    requestParameters,
    ignoreCache,
    serviceInstanceType,
  );

  // Data provider exception preserved even if next execution succeed, that is
  // why we can't rely on getDataProviderExceptions to check if call succeeded,
  // but should rely on value of the data.
  if (data != null) {
    return data;
  }

  const exception = contributionService.getDataProviderExceptions()[contributionId];
  if (exception) {
    throw exception;
  } else {
    // If data is either null or undefined type and no data provider exceptions, then
    // data provider call is successful and we can return null.
    return null;
  }
}

export async function loadNonNullData<T>(
  context: IVssPageContext,
  contributionId: string,
  requestParameters?: { [key: string]: any },
  ignoreCache?: boolean,
  serviceInstanceType?: string,
  errorMessage?: string,
): Promise<T> {
  const data = await loadData<T>(
    context,
    contributionId,
    requestParameters,
    ignoreCache,
    serviceInstanceType,
  );
  if (data == null) {
    throw new Error(errorMessage || "Data provider returned null instead of an actual value.");
  }
  return data;
}
